import React, { useState, useEffect } from "react";
import { Row, Col, Container, Form, Button, Image } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

//img
import logo from '../../../assets/images/logo.png'
import authBackground from '../../../assets/images/login/loginoage background 1.png'

//import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";

import { ToastProvider, useToasts } from 'react-toast-notifications';
import Swal from 'sweetalert2'
//import { useRouter } from 'next/navigation'
import { apiHandler, getApiErrorMessage } from '../../../api/apihandler';
import { LOGIN_WITH_EMAIL, LOGIN_WITH_EMAIL_OTP_MATCH, MATCH_EMAIL_OTP, PROFILE_DETAILS, RESEND_OTP, SIGNUP, VERIFY_EMAIL } from "../../../api/constants";

// Redux Selector / Action
import { useDispatch } from 'react-redux';
// import state selectors
import { setUserData } from '../../../store/setting/actions'
import { getAuthenticatedDefaultPath, isParentLoginProfile, setStoredParentStudentId } from '../../../utilities/teacherModulePermissions';

const LoginWithOTP = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { addToast } = useToasts();
    const [showTicketBuy, setShowTicketBuy] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [step, setStep] = useState(1)
    const [email, setEmail] = useState('')
    const [otp, setOtp] = useState('')
    const [startCountDownTimer, setStartCountDownTimer] = useState(false);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

   useEffect(() => {
      //console.log("eventId",localStorage.getItem("uzoneSelectedTicketId"))
      const interval = setInterval(() => {
         if (seconds > 0) {
            setSeconds(seconds - 1);
         }

         if (seconds === 0) {
            if (minutes === 0) {
               clearInterval(interval);
            } else {
               setSeconds(59);
               setMinutes(minutes - 1);
            }
         }
      }, 1000);

      return () => {
         clearInterval(interval);
      };
   });

   const handleSubmit = () => {
    if (step == 1) {
        if (email.toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            verifyEmail();
        } else {
            Swal.fire({
                title: 'Error!',
                text: "Enter valid email!",
                icon: 'error',
                confirmButtonText: 'Okay'
             })
        }
    } else if (step == 2) {
        matchEmailOtp();
    }
   }

   async function verifyEmail() {
    const res = await apiHandler(LOGIN_WITH_EMAIL, "POST", {
        email: email
    })
    if (res.status === 200) {
        // setMinutes(0)
        // setSeconds(10)
        // setStartCountDownTimer(true)
        setStep(2)
    } else {
        addToast(getApiErrorMessage(res, 'Could not verify that email. Please try again.'), { appearance: 'error' });
    }
}

async function reSendOTPApi() {
    const res = await apiHandler(RESEND_OTP, "POST", {
        email: email
    })
    if (res.data?.response?.status === 200) {
        addToast("OTP has been sent to your " + email, { appearance: 'success' });
        setMinutes(0)
        setSeconds(20)
        // setStartCountDownTimer(true)
    } else {
        addToast(getApiErrorMessage(res, 'Could not resend the OTP. Please try again.'), { appearance: 'error' });
    }
}

async function matchEmailOtp() {
    const res = await apiHandler(LOGIN_WITH_EMAIL_OTP_MATCH, "POST", {
        email: email,
        otp: otp
    })
    if (res.status === 200) {
      const user = res?.data?.data?.user;
        localStorage.setItem('uzoneAuthToken', res?.data?.data?.token?.token)
      // Clear out any parent/child selection left over from a previous session
      // on this device before making any further calls.
      setStoredParentStudentId(null)
      dispatch(setUserData(JSON.stringify(user)));
      // A parent account's PROFILE_DETAILS response includes a sibling `children`
      // array (one entry per linked student). Merge it in before navigating, and
      // store the default-selected child's id — the canonical value apiHandler
      // attaches to every subsequent API call.
      const profileRes = await apiHandler(PROFILE_DETAILS, "POST")
      const fullUser = profileRes?.data?.data?.user || user
      const children = profileRes?.data?.data?.children
      const mergedUser = Array.isArray(children) ? { ...fullUser, children } : fullUser
      // Only auto-select when there's exactly one child — with more than one,
      // leave the selection unset so student-dashboard.js's "select a child"
      // prompt appears on this first landing instead of silently guessing.
      if (isParentLoginProfile(mergedUser) && Array.isArray(children) && children.length === 1) {
         setStoredParentStudentId(children[0]?.id)
      }
      dispatch(setUserData(JSON.stringify(mergedUser)));
      navigate(getAuthenticatedDefaultPath(mergedUser))
    } else {
        addToast(getApiErrorMessage(res, 'OTP verification failed. Please try again.'), { appearance: 'error' });
    }
}

   return (
      <>
         <ToastProvider>
            <section
               className="sign-in-page auth-fullscreen-page"
               style={{ background: `linear-gradient(rgba(20, 35, 66, 0.48), rgba(20, 35, 66, 0.48)), url("${authBackground}") center / cover no-repeat` }}
            >
               <div id="container-inside">
                  <div id="circle-small"></div>
                  <div id="circle-medium"></div>
                  <div id="circle-large"></div>
                  <div id="circle-xlarge"></div>
                  <div id="circle-xxlarge"></div>
               </div>
                  <Link to="/" className="auth-home-btn">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
                     Home
                  </Link>
                  <Container className="p-0 auth-fullscreen-container">
                  <Row className="no-gutters auth-page-row">
                     <Col md="6" className="auth-form-col bg-white pt-5 pt-5 pb-lg-0 pb-5">
                        <div className="sign-in-from">
                           <Link className="sign-form-logo" to="/">
                              <Image src={logo} className="img-fluid" alt="logo" />
                           </Link>
                           <h1 className="mb-0">Guest user login</h1>
                           <p>Login with OTP</p>
                           <Form className="mt-4">
                              {step == 1 && <Form.Group className="form-group">
                                 <Form.Label>Your Email Address *</Form.Label>
                                 <Form.Control type="email" className="mb-0" id="exampleInputEmail1" placeholder="Email address"
                                    value={email} onChange={(e) => setEmail(e.target.value)} />
                              </Form.Group>}
                              {step == 2 && <Form.Group className="form-group">
                                 <Form.Label>OTP *</Form.Label>
                                 <Form.Control type="text" className="mb-0" id="exampleInputEmail2" placeholder="Enter OTP"
                                    value={otp} onChange={(e) => setOtp(e.target.value)} />
                              </Form.Group>}
                              <div className="d-inline-block w-100">
                                 {
                                    step === 2 ?
                                       <>
                                          {seconds > 0 || minutes > 0 ? (
                                             <span className="dark-color d-inline-block line-height-2">
                                                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                                {seconds < 10 ? `0${seconds}` : seconds}
                                             </span>
                                          ) : (
                                             <span className="dark-color d-inline-block line-height-2">Didn't recieve code?
                                                <Link to="#" onClick={() => reSendOTPApi()}> Resend OTP</Link>
                                             </span>
                                          )}
                                       </> : null
                                 }
                                 <Button type="button" className="btn-primary float-end" onClick={() => {
                                    //history.push('/')
                                    handleSubmit()
                                 }}>
                                    {step == 2 ? 'Register' : 'Next'}
                                 </Button>
                              </div>
                              <div className="sign-info">
                                 <span className="dark-color d-inline-block line-height-2">Already Have an Account ? <Link to="/auth/sign-in">Log In</Link></span>
                              </div>
                           </Form>
                        </div>
                     </Col>
                  </Row>
               </Container>
            </section>
         </ToastProvider>
      </>
   )
}

export default LoginWithOTP
